module.exports = __webpack_public_path__ + "static/media/mellow-icon.1fe731c6.png";